import FlowTemplate from '../Onboarding/FlowTemplate';

function OnboardingTemplate({ children, showRightPanel = true, headerExtra = null }) {
  return (
    <FlowTemplate showRightPanel={showRightPanel} headerExtra={headerExtra}>
      {children}
    </FlowTemplate>
  );
}

export default OnboardingTemplate;
